<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_ptb0lr24 s_bf p-t-24">
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">  
          <a-button size='small' @click="()=>{$router.go(-1)}" class="mr10">
          <LeftOutlined />返回
         </a-button> 
         订单操作
         </p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35 s_fonts16"><span class="m-r-15">订单状态：{{orderData.order_status_text}}</span><span>订单号：{{orderData.order_no}}（{{orderData.delivery_type == 1 ?'快递发货':'门店自提'}}）</span></p>
          <a-divider :hidden='orderData.order_status == 9' />
          <div class="s_flex_ali" :hidden='orderData.order_status == 9'>
            <p class="m-r-15">你可以：</p>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_status == 1 || orderData.order_status == 2) && orderData.delivery_type == 1' v-has:orderDetailEditAddress='getAddress'>修改地址</a-button>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_status == 1 || orderData.order_status == 6) && orderData.delivery_type == 1' v-has:orderDetailShip='()=>orderDeliver(1)'>发货</a-button>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_status == 4 || orderData.order_status == 2 || orderData.order_status == 3) && orderData.delivery_type == 1' v-has:orderDetailLogistics='getLogistics'>物流信息</a-button>
            <a-button class="m-r-15" type="primary" v-if='orderData.order_status == 1 && orderData.order_type !== 5' v-has:orderDetailRefunds='orderRefunds'>退款</a-button>
            <!-- <a-button class="m-r-15" type="primary" v-if='orderData.order_status == 2 && orderData.delivery_type == 1' @click='orderDeliver(2)'>修改发货</a-button> -->
            <a-button type="danger" v-if='orderData.order_status == 5 && orderData.order_type !== 5' v-has:orderDetailAfter="()=> {$router.push('/order/order_manage/return_order_more?id='+$route.query.id)}">售后处理</a-button>
            <a-button type="link" v-has:orderDetailRemarks='getRemarks'>订单备注</a-button>
          </div>
          <div class="s_flex_ali m-t-20 p-15 s_bf7 m-l-70" v-if='orderData.store_remark'>
            订单备注：{{orderData.store_remark}}
          </div>
        </div>
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">订单详情</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">订单类型：{{orderData.order_type_text}}</p>
          <p class="s_c333  s_lin_h35">
            收货信息：{{orderData.delivery_type == 1 ? orderData.extract.name :  orderData.extract.extract_name}}，{{orderData.delivery_type == 1 ? orderData.extract.phone : orderData.extract.extract_phone}}<span v-if='orderData.delivery_type == 1'>，{{orderData.area|| orderData.extract.detail}}</span>
          </p>
          <p class="s_c333  s_lin_h35">{{$route.query.is_activity?'发货方式：':'领取方式：'}}{{orderData.delivery_type_text}}</p>
          <p class="s_c333  s_lin_h35">发货门店：{{orderData.store_name}}</p>
          <p class="s_c333  s_lin_h35">所属上级：{{orderData.parent_name}}</p>
          <p class="s_c333  s_lin_h35">应付金额：￥{{orderData.total_price}}<span v-if="orderData.order_type == 5">+{{orderData.point_num}}积分</span></p>
          <p class="s_c333  s_lin_h35">支付方式：{{orderData.pay_type_texts}}</p>
          <p class="s_c333  s_lin_h35">交易号：{{orderData.adpay_current_no || '-'}}</p>
          <p class="s_c333  s_lin_h35">付款时间：{{orderData.pay_time || '-'}}</p>
          <p class="s_c333  s_lin_h35">物流公司：{{orderData.extract.express_company || '-'}}</p>
          <p class="s_c333  s_lin_h35">物流单号：{{orderData.extract.express_no || '-'}}</p>
          <p class="s_c333  s_lin_h35">发货时间：{{orderData.delivery_time || '-'}}</p>
          <p class="s_c333  s_lin_h35">签收时间：{{orderData.settled_time || '-'}}</p>
          <p class="s_c333  s_lin_h35">买家留言：{{orderData.buyer_remark || '暂无留言'}}</p>
          <a-divider />
          <p class="s_c333 s_fonts14  m-b-20">买家信息：</p>
          <div class="s_flex_bian_c">
            <p class="width30 s_c333 ">微信昵称：{{orderData.member_name}}</p>
            <p class="width30 s_c333 ">会员ID：{{orderData.user_id}}</p>
            <p class="width30 s_c333 ">会员等级：{{orderData.vip_level}}</p>
          </div>
          <a-divider />
          <p class="s_c333 s_fonts14  m-b-20">商品清单：</p>
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsGood' :data-source='orderData.product_list'>
            <template v-slot:good="{ record }">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px">
                </template>
                <template #description>
                  <p class="s_omit">{{record.product_name}}</p>
                </template>
              </a-card-meta>
            </template>
            <template v-slot:product_price="{ record }">
              <p>￥{{record.product?record.product.product_price : '-'}}<span v-if="orderData.order_type == 5">+{{record.product?record.product.point: '-'}}积分</span></p>
            </template>
            <template v-slot:coupon_price="{ record }">
              <p>{{record.coupon_price || '-'}}</p>
            </template>
            <template v-slot:total_pay_price="{ record }">
              <p>￥{{record.total_pay_price}}<span v-if="orderData.order_type == 5">+{{record.total_pay_point}}积分</span></p>
            </template>
          </a-table>
          <div class="s_flex_bian m-t-25">
            <div class="s_c333 ">
              <span class="m-r-20">商品数量总计：{{allNum}} </span><span>总重量：{{allWeight}}KG</span>
            </div>
            <div class="s_c333 ">
              <p class="m-b-10">商品总金额：¥{{orderData.total_price}}</p>
              <p class="m-b-10" v-if="orderData.order_type == 5">总积分：{{orderData.point_num}}</p>
              <p class="m-b-5"> 运费：¥ {{orderData.freight_price}}</p>
              <p>订单金额：¥ 
                <span class="fz-20 s_cd41">{{orderData.pay_price}}</span>
                <span class="m-l-5 m-r-5" v-if="orderData.order_type == 5">+</span>
                <span class="fz-20 s_cd41" v-if="orderData.order_type == 5">{{orderData.point_num}}</span>
                <span v-if="orderData.order_type == 5">积分</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">操作记录</p>
        <div class="s_p24">
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsRecord' :data-source='orderData.operation_log'>
            <template v-slot:user="{ record }">
              <p>{{record.operator_type}}<span v-if='record.user'>：{{record.user.member_name}}</span></p>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <a-modal  :keyboard="false" title="订单备注" centered v-model:visible="showRemarks" :confirm-loading="confirmLoading" @ok="eidtRemarks" destroyOnClose>
      <a-textarea v-model:value="orderRemarks" placeholder="请输入订单备注内容" :rows="4" />
    </a-modal>
    <a-modal  :keyboard="false" title="修改收货地址" :width='600' centered :footer="null" v-model:visible="showAddress" destroyOnClose>
      <addressChange :addressData='addressData' v-on:submitaddress='submitAddress'></addressChange>
    </a-modal>
    <a-modal  :keyboard="false" title="退款" :width='600' centered :footer="null" v-model:visible="showRefunds" destroyOnClose>
      <refundsForem :refundsData='refundsData' type='list' v-on:submitrefunds='submitrefunds'></refundsForem>
    </a-modal>
    <a-modal  :keyboard="false" :title="deliverType == 1 ?'标记发货':'修改发货'" :width='1300' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
      <deliverForem :deliverData='deliverData' :type='deliverType' :isInsteadShip='1' v-on:submitdeliver='submitdeliver'></deliverForem>
    </a-modal>
    <a-modal  :keyboard="false" title="物流信息" :width='800' centered :footer="null" v-model:visible="showLogistics" destroyOnClose>
      <logisticsDetails :data='logisticsData'></logisticsDetails>
    </a-modal>
  </a-layout>
</template>

<script>
 import { LeftOutlined} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";
import {
  orderAddressEdit,
  setOrderRemark,
  getOrderRemark,
  orderAddressMore,
  getOrderMore,
  getOrderLogistics
} from "@/api/order";
import { iscode } from "@/utils/app";
import logisticsDetails from '../components/logisticsDetails'
export default {
  components: {
    LeftOutlined,logisticsDetails
  },
  setup() {
    const state = reactive({
      showAddress: false,
      showRefunds: false,
      showDeliver: false,
      listLoading: false,
      showRemarks: false,
      showLogistics:false,
      addressData: {},
      deliverData: {},
      refundsData: {},
      orderRemarks: "",
      deliverType: 1,
      confirmLoading: false,
      info: store.state.user.info,
      orderData: {
        extract: {},
      },
      allNum: 0,
      allWeight: 0,
      logisticsData:{}
    });
    let columnsGood = [
      {
        title: "商品信息",
        key: "good",
        slots: { customRender: "good" },
      },
      {
        title: "数量",
        dataIndex: "buy_num",
        key: "buy_num",
      },
      {
        title: "售价",
        dataIndex: "product_price",
        key: "product_price",
        slots: { customRender: "product_price" },
      },
      {
        title: "优惠",
        dataIndex: "coupon_price",
        key: "coupon_price",
        slots: { customRender: "coupon_price" },
      },
      {
        title: "小计",
        dataIndex: "total_pay_price",
        key: "total_pay_price",
        slots: { customRender: "total_pay_price" },
      },
    ];
    let columnsRecord = [
      {
        title: "操作时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作人",
        dataIndex: "user",
        key: "user",
        slots: { customRender: "user" },
      },
      {
        title: "操作动作",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "信息",
        dataIndex: "remark",
        key: "remark",
      },
    ];
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const _lodash = inject("_lodash");

    //获取备注
    const getRemarks = async (e) => {
      let res = await getOrderRemark({ order_no: $route.query.id }).then((res) => res.data).catch((error) => error);
      if (iscode(res)) {
        state.showRemarks = true;
        state.orderRemarks = res.data.store_remark;
      } else {
        message.error(res.msg);
      }
    };
    //修改备注
    const eidtRemarks = async () => {
      state.confirmLoading = true;
      let res = await setOrderRemark({order_no: $route.query.id,store_remark: state.orderRemarks}).then((res) => res.data).catch((error) => error);
      if (iscode(res)) {
        state.showRemarks = false;
        state.orderRemarks = "";
        message.success(res.msg);
        initData();
      } else {
        message.error(res.msg);
      }
      state.confirmLoading = false;
    };
    //获取订单地址
    const getAddress = async (e) => {
      let res = await orderAddressMore({ order_no: $route.query.id }).then((res) => res.data).catch((error) => error);
      if (iscode(res)) {
        state.showAddress = true;
        res.data[0].detail = res.data[0].detail.split(",")[1];
        state.addressData = res.data[0];
      } else {
        message.error(res.msg);
      }
    };
    //确认修改地址
    const submitAddress = () => {
      state.showAddress = false;
      initData();
    };
    //打开退货弹窗
    const orderRefunds = () => {
      state.refundsData = {
        pay_price: state.orderData.pay_price,
        order_no: $route.query.id,
      };
      state.showRefunds = true;
    };
    //退货
    const submitrefunds = () => {
      state.showRefunds = false;
      initData();
    };
    //打开发货弹窗
    const orderDeliver = (type) => {
      state.deliverType = type;
      state.deliverData = {
        order_no: $route.query.id,
        detail: state.orderData.product_list,
        extract: state.orderData.extract,
      };
      state.showDeliver = true;
    };
    //发货
    const submitdeliver = () => {
      state.showDeliver = false;
      initData();
    };
    //获取物流信息
    const getLogistics = async() =>{
      let res = await getOrderLogistics({ order_no: $route.query.id }).then((res) => res.data).catch((error) => error);
      if (iscode(res)) {
        state.showLogistics = true;
        state.logisticsData = res.data;
      } else {
        message.error(res.msg);
      }
    }
    //获取详情
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let  res = await getOrderMore({ order_no: $route.query.id }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        var list = res.data.product_list || [];
        var num = 0;
        var product_weight = 0;
        for (var i in list) {
          num = +list[i].buy_num;
          product_weight = list[i].buy_num * (list[i].product ? list[i].product.product_weight : 0);
        }

        state.allNum = num || 0;
        state.allWeight = product_weight || 0;
        state.orderData = res.data;
      } else {
        message.error(res.msg);
      }

      setTimeout(hide);
    };

    //  const goBack = ()=>{
    //    window.history.go(-1)
    //  }

    onMounted(() => {
      initData();
    });
    return {
      columnsRecord,
      columnsGood,
      ...toRefs(state),
      submitAddress,
      eidtRemarks,
      getRemarks,
      getAddress,
      orderDeliver,
      orderRefunds,
      submitrefunds,
      submitdeliver,
      getLogistics
      // goBack
    };
  },
};
</script>

